import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import OffersCardDetails from '../../../atoms/Card/OffersCardDetails';

const Destinations =()=>{
    return(
        <>
          <section className='destinations-section section-padding'>
            <Container >
                <Row className='mb-4'>
                    <Col className="col-12 col-md-12 text-center">
                        <h2 className='promocode-section--h2 h2'>Today's car rental and van rental offers</h2>
                    </Col>
                </Row>
                <Row >
                    <OffersCardDetails />
                </Row>
                
            </Container>
          </section>
        </>
    )
}
export default Destinations